export const environment = {
  production: true,
  // Deployed MAIS instance for this shared build - unlike environment.ts's localhost default
  // (only reachable when developing locally). Still user-overridable via the Options page, same
  // as authToken/workspaceSlug - see AiConfigService.
  maisApiBaseUrl: 'https://aws-dev.mitel-ai-services.dev/api'
};
